import React, {useState, useContext} from "react";
import "../../../../channels/styles/templateList.css";

import { Tooltip, Popover } from "antd";
import dayjs from "dayjs";
import { getRandomColorsBassedOnLetters } from "helper/colors";
import { useNavigate } from "react-router-dom";
import Tick from "../../../../../assets/customSVG/Tick";
import { ICONS } from "../../../../../assets/icons";
import { contactSourceIcons } from "../../../../../constant/app/crm/crm";
import { hexToRgba } from "../../../helpers";
import Label from "../../commonComponents/label";
import Tags from "../../main/contact/Tags";
import { useSelector } from "react-redux";
import { crmTagRemove, crmTagSingleAssign, crmTags } from "../../../api/Api";
import { showErrorToast, showSuccessToast } from "../../../../../../src/components/commonComponents/gxAntdToast/toastUtils";
import NotificationContext from "../../../../../providers/NotificationProvider";
import { useDispatch } from "react-redux";
import { setTagList } from "../../../../../reduxToolkit/crmSlice";

export default function CrmTable({
  data,
  isLoading,
  visibleColumns,
  isFilter,
  selected,
  onSelect,
  handleRemoveTag,
  handleAddTag,
}) {
  const notification = useContext(NotificationContext);
  const tdStyle = " pr-[0.5vw] !text-[0.85vw] !font-[500] text-[#616874]";

  const truncateName = (name, length) => {
    return name.length > length ? `${name.substring(0, length)}...` : name;
  };

  const firstName = truncateName(data?.first_name || "", 15);
  const lastName = truncateName(data?.last_name || "", 15);
  const fullName = `${data?.first_name || ""} ${data?.last_name || ""}`;
  const name = `${firstName} ${lastName}`;
  const email1 = data?.person_contacts?.find(
    (item) =>
      item?.priority === 1 && item?.contact_type_name === "Email address"
  )?.email;

  const crmFontColor = "#616874";

  const navigate = useNavigate();
  const firstLetter = firstName?.slice(0, 1).toUpperCase() || "";
  const colors = getRandomColorsBassedOnLetters(firstLetter);

  const handleNavigate = (id) => {
    const colors = getRandomColorsBassedOnLetters(firstLetter);
    navigate(`/user/crm/${id}`, { state: { colors } });
  };

  const { currentBrand } = useSelector((state) => state.app);
  const brandId = currentBrand?.brand_id;

  const [showingTagsForContact, setShowingTagsForContact] = useState(null);
  const [currentContact, setCurrentContact] = useState(null);
  const [isTagsDropdownOpen, setIsTagsDropdownOpen] = useState(false);
  const [contactTags, setContactTags] = useState([]);
  const dispatch = useDispatch();

  const showAdditionalTags = (contactId) => (e) => {
    e.stopPropagation();
    setShowingTagsForContact(showingTagsForContact === contactId ? null : contactId);
  };

  const toggleTagsDropdown = async (e, contactId) => {
    e?.stopPropagation();
    if (contactId && !isTagsDropdownOpen) {
      try {
        const res = await crmTags(brandId, contactId);
        if (res?.data?.status === 200) {
          setContactTags(res.data.data || []);
          dispatch(setTagList(res.data.data || []));
        }
      } catch (error) {
        console.error('Error fetching contact tags:', error);
      }
    }
    setIsTagsDropdownOpen(!isTagsDropdownOpen);
  };

  const contactSource = data?.contact_origin || "--";
  const contactIcon = contactSourceIcons[contactSource];

  const maxVisibleTags = 2;

  const visibleTags = data?.tags?.slice(0, maxVisibleTags);
  const additionalTagCount = data?.tags?.length - maxVisibleTags;

  return (
    <>
      {/* {name?.toLowerCase()?.includes(isFilter?.toLowerCase()) && ( */}
      <tr
        className={`border-[0.8vw] !rounded-[0.4vw] overflow-hidden group/container pointer`}
        style={{
          height: "2vh !important",
        }}
      >
        <td className=" bg-white z-[50]">
          <div className="">
            <input
              type="checkbox"
              name="checkbox"
              checked={selected}
              onChange={onSelect}
              className="accent-[var(--new-primary)]"
            />
          </div>
        </td>
        <td className="" onClick={() => handleNavigate(data?.id)}>
          <div className="crm-table-list w-full max-w-[200px] h-[1.6vw]">
            <div className="flex-row align-center">
              <div
                className="size-10 min-w-10 border-2 border-white rounded-full text-[var(--font-600)] text-base weight-semibold flex items-center capitalize justify-center bg-gray-100"
                style={{
                  color: "white",
                  backgroundColor: colors.color
                }}
              >
                {firstLetter}
              </div>
              <div className="flex flex-1 text-left pl-10">
                {name?.length > 20 ? (
                  <Tooltip title={fullName}>
                    <h4
                      className={`w-1/2 text-[0.85vw] font-[500] capitalize text-[#616874] truncate`}
                    >
                      {fullName}
                    </h4>
                  </Tooltip>
                ) : (
                  <h4
                    className={`text-[0.85vw] font-[500] capitalize text-[#616874]`}
                  >
                    {name}
                  </h4>
                )}
              </div>
            </div>
          </div>
        </td>

        <td
          className={`${tdStyle} w-full h-[3.5vw] flex items-center justify-center !text-[0.85vw]`}
        >
          {/* {data?.person_contacts?.map((item) =>
              item?.priority === 1 && item?.contact_type === "MOBILE_PHONE" ? (
                <>
                  {item?.phone_country_code && (
                    <span className="pr-5">(+{item.phone_country_code})</span>
                  )}
                  {item?.phone_number || "--"}
                </>
              ) : (
                ""
              )
            )} */}
          {data?.person_contacts?.filter(
            (item) => item?.priority === 1 && item?.phone_number !== null
          ).length > 0
            ? data.person_contacts.map((item) =>
                item?.priority === 1 && item?.phone_number !== null ? (
                  <React.Fragment key={item?.id}>
                    {item?.phone_country_code && (
                      <span className="pr-5">
                        (+{item?.phone_country_code})
                      </span>
                    )}
                    {item?.phone_number}
                  </React.Fragment>
                ) : null
              )
            : "--"}
        </td>
        <td className={`${tdStyle} max-w-[1vw]`}>
          {email1?.length > 25 ? (
            <Tooltip title={email1}>
              <div className="w-full text-[0.85vw] truncate overflow-hidden whitespace-nowrap pb-1">
                {email1 || "--"}
              </div>
            </Tooltip>
          ) : (
            <div className="w-full text-[0.85vw] truncate overflow-hidden whitespace-nowrap pb-1">
              {email1 || "--"}
            </div>
          )}
        </td>

        <td className={`${tdStyle}`}>
          {contactIcon ? (
            <div className="flex-row gap-2 pl-16 ml-5">
              <img src={contactIcon} alt={contactSource} className="w-[22px]" />
              {contactSource}
            </div>
          ) : (
            "--"
          )}
        </td>
        {/* {visibleColumns?.includes("Life Cycle Stage") && (
            <td className={`${tdStyle}`}>{data?.life_cycle_stage || "--"}</td>
          )} */}
        <td className={`${tdStyle}`}>
          {data?.created_at
            ? dayjs(data?.created_at).format("ddd MMM DD YYYY")
            : "--"}
        </td>
        {visibleColumns?.includes("Country") && (
          // <td className={`${tdStyle}`}>
          //   <img src={ICONS?.alertFilled} alt="" />
          //   {data?.country || "--"}
          // </td>
          <td className={`${tdStyle}`}>
            <Popover
              content={data?.country ? <div className="px-10 py-3 pointer">{data?.country}</div> : null}
              trigger="click"
              arrow={false}
            >
              <div className="flex-row gap-2 pl-16 ml-20">
                {/* <img src={ICONS?.alertIconError} alt="" /> */}
                {data?.country || "--"}
              </div>
            </Popover>
          </td>
        )}

        {visibleColumns?.includes("State") && (
          <td className={`${tdStyle}`}>{data?.province || "--"}</td>
        )}
        {visibleColumns?.includes("City") && (
          <td className={`${tdStyle}`}>{data?.city || "--"}</td>
        )}
        {visibleColumns?.includes("Tags") && (
          <td className={`${tdStyle}`}>
            <div className="flex-row align-center justify-center gap-2">
              {Array.isArray(visibleTags) && visibleTags?.length > 0 ? (
                visibleTags?.map((tag) => {
                  return (
                    <Label
                      id={tag?.id}
                      key={tag?.id}
                      label={tag?.tag}
                      color={tag?.display_color}
                      style={{
                        backgroundColor: hexToRgba(tag?.display_color, 0.2),
                      }}
                      mainClassNames="w-40"
                      disableHover={true}
                      showClose={true}
                      closeAction={(e) => {
                        e.stopPropagation();
                        handleRemoveTag(data.id, tag.id);
                      }}
                    />
                  );
                })
              ) : (
                <span></span>
              )}
              {additionalTagCount > 0 && (
                // Popover for additional tags
                <Popover
                  content={
                    <div className="flex-row align-center justify-center gap-2 px-3 py-3 bg-[#FAFAFA] rounded-lg">
                      {(data.tags?.slice(2) || []).filter(tag => tag && tag.id).map((tag) => (
                        <Label
                          key={tag?.id}
                          id={tag?.id}
                          label={tag?.tag}
                          color={tag?.display_color}
                          style={{
                            backgroundColor: hexToRgba(tag?.display_color, 0.2),
                          }}
                          disableHover={true}
                          showClose={true}
                          closeAction={(e) => {
                            e.stopPropagation();
                            handleRemoveTag(data?.id, tag?.id);
                          }}
                        />
                      ))}
                    </div>
                  }
                  trigger="click"
                  open={showingTagsForContact === data?.id}
                  onOpenChange={(visible) => {
                    if (!visible) setShowingTagsForContact(null);
                  }}
                >
                  <span
                    className="text-[0.85vw] text-[var(--font-400)] bg-[var(--channelButton)] rounded-full p-1 cursor-pointer"
                    onClick={showAdditionalTags(data?.id)}
                  >
                    {`+${additionalTagCount}`}
                  </span>
                </Popover>
              )}
              <div className="relative">
                <Tags
                  active={isTagsDropdownOpen && currentContact === data?.id}
                  toggle={(e) => {
                    setCurrentContact(data?.id);
                    toggleTagsDropdown(e, data?.id);
                  }}
                  className=""
                  Button={
                    <div className="flex text-[#616874] text-[0.85vw] items-center font-[500] gap-[.4vw] cursor-pointer">
                      <img
                        src={ICONS?.addTags}
                        alt="addTags"
                        className="cursor-pointer"
                      />
                    </div>
                  }
                  zIndex={100}
                  tags={data?.tags || []}
                  removeFunction={(tagId) => handleRemoveTag(data?.id, tagId)}
                  addFunction={(tagId) => handleAddTag(data?.id, tagId)}
                />
              </div>
            </div>
          </td>
        )}
          {visibleColumns?.includes("Last Contacted") && (
            <td className={`${tdStyle} text-[0.85vw]`}>
              {/* {dayjs(data?.last_contacted_at).format("ddd MMM DD YYYY") || "--"} */}
              {data?.last_contacted_at
                ? dayjs(data?.last_contacted_at).format("ddd MMM DD YYYY")
                : "--"}
            </td>
          )}
          {visibleColumns?.includes("Alternative Mobile") && (
            <td
              className={`${tdStyle} w-full h-[3.5vw] flex items-center justify-center`}
            >
              {data?.person_contacts?.filter(
                (item) => item?.priority === 2 && item?.phone_number !== null
              ).length > 0
                ? data.person_contacts.map((item) =>
                    item?.priority === 2 && item?.phone_number !== null ? (
                      <React.Fragment key={item?.id}>
                        {item?.phone_country_code && (
                          <span className="pr-5">
                            (+{item?.phone_country_code})
                          </span>
                        )}
                        {item?.phone_number}
                      </React.Fragment>
                    ) : null
                  )
                : "--"}
            </td>
          )}
          {visibleColumns?.includes("First Name") && (
            <>
              {firstName?.length > 15 ? (
                <Tooltip title={firstName}>
                  <td className={`${tdStyle} capitalize`}>
                    {firstName || "--"}
                  </td>
                </Tooltip>
              ) : (
                <td className={`${tdStyle} capitalize`}>{firstName || "--"}</td>
              )}
            </>
          )}
          {visibleColumns?.includes("Last Name") && (
            <>
              {lastName?.length > 15 ? (
                <Tooltip title={lastName}>
                  <td className={`${tdStyle} capitalize`}>
                    {lastName || "--"}
                  </td>
                </Tooltip>
              ) : (
                <td className={`${tdStyle} capitalize`}>{lastName || "--"}</td>
              )}
            </>
          )}
          {visibleColumns?.includes("Whatsapp Opt In") && (
            <td className={`${tdStyle}`}>
              {data?.opted_out?.whatsapp ? (
                <td className={`${tdStyle}`}>
                  <Tick
                    stroke={crmFontColor}
                    width="15vw"
                    height="10"
                    strokeWidth="3"
                  />
                </td>
              ) : (
                "--"
              )}
            </td>
          )}
          {visibleColumns?.includes("Email Opt Out") && (
            <td className={`${tdStyle}`}>
              {data?.opted_out?.email ? (
                <td className={`${tdStyle}`}>
                  <Tick
                    stroke={crmFontColor}
                    width="15vw"
                    height="10"
                    strokeWidth="3"
                  />
                </td>
              ) : (
                "--"
              )}
            </td>
          )}
          {visibleColumns?.includes("SMS Opt Out") && (
            <td className={`${tdStyle}`}>
              {data?.opted_out?.sms ? (
                <td className={`${tdStyle}`}>
                  <Tick
                    stroke={crmFontColor}
                    width="15vw"
                    height="10"
                    strokeWidth="3"
                  />
                </td>
              ) : (
                "--"
              )}
            </td>
          )}
      </tr>
      {/* )} */}
    </>
  );
}
